import { Column, Table } from '@tanstack/react-table';
import { useMemo } from 'react';

import { MenuCombobox } from '../../../menu-select';

type TableMenuColumnOption<TData> = {
  value: string;
  label?: string;
  column: Column<TData, unknown>;
};

export function TableMenuColumnSelect<TData>({
  table,
  placeholder,
  shouldDisplayColumn,
  onSelect,
}: {
  table: Table<TData>;
  placeholder?: string;
  shouldDisplayColumn: (column: Column<TData, unknown>) => boolean;
  onSelect: (column: Column<TData, unknown>) => void;
}) {
  const columns = table.getAllColumns();
  const options = useMemo<TableMenuColumnOption<TData>[]>(
    () =>
      columns.filter(shouldDisplayColumn).map((column) => ({
        value: column.id,
        label: column.columnDef.meta?.name,
        column,
      })),
    [columns, shouldDisplayColumn],
  );

  return (
    <MenuCombobox
      placeholder={placeholder}
      options={options}
      onChange={(value) => {
        if (value) {
          onSelect(value.column);
        }
      }}
    />
  );
}
